var map = {
	"./About.vue": [
		"f820",
		"chunk-2d22d746"
	],
	"./Auth.vue": [
		"2fef",
		"chunk-2d0be70b"
	],
	"./AuthBefore.vue": [
		"37c4",
		"chunk-969cf4ee",
		"chunk-2d0baa8b"
	],
	"./Class.vue": [
		"be7e",
		"chunk-969cf4ee",
		"chunk-5a636067"
	],
	"./ClassHotDetail.vue": [
		"0ba0",
		"chunk-969cf4ee",
		"chunk-10d9d37c"
	],
	"./History.vue": [
		"e4bb",
		"chunk-969cf4ee",
		"chunk-bb33b18c"
	],
	"./Home.vue": [
		"bb51",
		"chunk-969cf4ee",
		"chunk-4c3e20b3"
	],
	"./InviteShare.vue": [
		"c293",
		"chunk-969cf4ee",
		"chunk-4cdffa34"
	],
	"./Layout.vue": [
		"88e9",
		"chunk-969cf4ee",
		"chunk-43e7cd50"
	],
	"./Login.vue": [
		"a55b",
		"chunk-969cf4ee",
		"chunk-2d2086b7"
	],
	"./MyCollection.vue": [
		"b054",
		"chunk-969cf4ee",
		"chunk-1c9251da"
	],
	"./Personal.vue": [
		"90ab",
		"chunk-969cf4ee",
		"chunk-2d0e4a6e"
	],
	"./Register.vue": [
		"73cf",
		"chunk-969cf4ee",
		"chunk-5310d6dc"
	],
	"./Search.vue": [
		"2d3b",
		"chunk-969cf4ee",
		"chunk-5def066f"
	],
	"./SignList.vue": [
		"a389",
		"chunk-969cf4ee",
		"chunk-8d7cf9b0"
	],
	"./UserAgreement.vue": [
		"40c9",
		"chunk-2d0c04a8"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;